class FSAddToCart extends HTMLElement {
  connectedCallback() {
    this.atc = this.closest(".fs_actions").querySelector(".add-to-cart-button");
    this.addEventListener('click', this.handleClick);
  }

  disconnectedCallback() {
    this.removeEventListener('click', this.handleClick);
  }

  handleClick = async () => {
    if (this.hasAttribute('disabled')) return;
    if (!this.atc) return;

    const originalText = this.textContent.trim();

    this.setAttribute('disabled', '');
    this.textContent = 'ADDING...';

    this.atc.click();

    setTimeout(() => {
      this.textContent = originalText;
      this.removeAttribute('disabled');
    }, 1200);
  };
}

if (!customElements.get('fs-add-to-cart')) {
  customElements.define('fs-add-to-cart', FSAddToCart);
}


class FSProductSlider extends HTMLElement {
    constructor() {
        super();
    }

    connectedCallback() {
      this.initSwiper();
    }
    
    initSwiper() {
      const swiper = new Swiper(this, {
        slidesPerView: 1,
        spaceBetween: 30,
        pagination: {
            el: '.swiper-pagination',
        },
      });
    }
}

if(!customElements.get('fs-product-swiper')){
    customElements.define('fs-product-swiper', FSProductSlider);
}


class FsSwiper extends HTMLElement {
      constructor() {
        super();
        this._instance = null;
        this._onReady = this._onReady.bind(this);
      }

      connectedCallback() {
        if (window.Swiper) {
          this.init();
        } else {
          window.addEventListener('fs:swiper-ready', this._onReady);
        }
      }

      disconnectedCallback() {
        window.removeEventListener('fs:swiper-ready', this._onReady);
        if (this._instance) {
          this._instance.destroy(true, true);
          this._instance = null;
        }
      }

      _onReady() {
        window.removeEventListener('fs:swiper-ready', this._onReady);
        this.init();
      }

      init() {
        if (this._instance) return;

        const swiperEl = this.querySelector('.swiper');
        if (!swiperEl || !window.Swiper) return;

        const paginationEl = this.querySelector('.swiper-pagination');
        const usePagination = this.dataset.pagination === 'true' && paginationEl;

        this._instance = new window.Swiper(swiperEl, {
          slidesPerView: 1.3,
          spaceBetween: 12,
          grabCursor: true,
          watchOverflow: true,
          pagination: usePagination
            ? {
                el: paginationEl,
                clickable: true,
              }
            : false,
          breakpoints: {
            768: {
              slidesPerView: 3,
            },
          },
        });
      }
}
customElements.define('fs-swiper', FsSwiper);

if(!customElements.get('fs-swiper')){
    customElements.define('fs-swiper', FsSwiper);
}